import { useRef } from "react";

import classnames from "classnames";
import { usePrefersReducedMotion } from "neetocommons/react-utils";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";

import AddNew from "./AddNew";
import Block from "./Block";
import Item from "./Item";
import Search from "./Search";
import SubTitle from "./SubTitle";

const MenuBar = ({
  title = "",
  children,
  showMenu = false,
  className = "",
  ...otherProps
}) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const nodeRef = useRef(null);

  return (
    <CSSTransition
      {...{ nodeRef }}
      unmountOnExit
      in={showMenu}
      timeout={prefersReducedMotion ? 0 : 300}
      onEnter={() => {
        if (nodeRef.current) nodeRef.current.style.width = "0";
      }}
      onEntered={() => {
        if (nodeRef.current) nodeRef.current.style.width = "";
      }}
      onEntering={() => {
        if (nodeRef.current) nodeRef.current.style.width = "20.25rem";
      }}
      onExit={() => {
        if (nodeRef.current) nodeRef.current.style.width = "20.25rem";
      }}
      onExiting={() => {
        if (nodeRef.current) nodeRef.current.style.width = "0";
      }}
    >
      <div
        ref={nodeRef}
        className={classnames(
          "border-border bg-background shrink-0 overflow-hidden border-e transition-all duration-300 motion-reduce:transition-none",
          className
        )}
      >
        <div
          className="h-dvh w-[20.25rem] overflow-y-auto p-8 max-lg:w-[17.5rem] max-lg:px-6 max-lg:pt-10 max-lg:pb-6 max-md:w-60 max-md:px-5 max-md:pt-10 max-md:pb-6"
          data-testid="menubar-container"
        >
          {title && (
            <h2
              className="mb-4 text-xl leading-tight font-semibold"
              data-testid={otherProps["data-testid"] || "menubar-heading"}
            >
              {title}
            </h2>
          )}
          {children}
        </div>
      </div>
    </CSSTransition>
  );
};

MenuBar.Block = Block;
MenuBar.Item = Item;
MenuBar.SubTitle = SubTitle;
MenuBar.Search = Search;
MenuBar.AddNew = AddNew;

MenuBar.propTypes = {
  title: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  showMenu: PropTypes.bool,
  className: PropTypes.string,
};

export default MenuBar;
